import React, { useState } from "react";
import mmclogo from "../../resources/img/mmclogo2.png";
import Spinner from "../spinner/Spinner";
import useMmcService from "../../services/MmcService";
import Login from "../login/Login";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import NavigationBar from "./NavigationBar";
import NavigationBarForTablet from "./NavigationBarForTablet";
import { useMediaQuery } from "react-responsive";
import ReportPrint from "./ReportPrint";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import {Consts} from "../pages/consts";

const AppHeader = ({
  manageUserLogin,
  onResetApp,
  loggedIn,
  registerAsPatient,
}) => {
  const { t: t } = useTranslation();
  const { loading } = useMmcService();
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  const isMobile = useMediaQuery({ maxWidth: 600 });

  const handleLogin = (token, role, userId, login, studyBranch) => {
    setShowLoginDialog(false);

    if (token) {
      manageUserLogin(`bearer ${token}`, role, userId, login, studyBranch);
    }
  };

  const handleLoginClick = () => {
    setShowLoginDialog(true);
  };

  const handleLogoutClick = () => {
    onResetApp();
  };

  const View = () => {
    return (
      <>
        <header className="w3-container w3-theme-l3 w3-center app-header">
          <div className="w3-row w3-padding-small w3-margin-top w3-margin-buttom app-header-row">
            {registerAsPatient && loggedIn ? (
              isTablet ? (
                <>
                  <div className="w3-col s12 m3 w3-padding-small app-header-logo app-header-logo-mobile">
                    <img src={mmclogo} alt="MMC logo" className="mmc-logo" />
                  </div>
                  <div className="w3-col s12 m9 app-header-mobile-panel">
                    <div className="app-header-actions app-header-actions-left app-header-toolbar-mobile">
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 app-header-button app-nav-toggle app-nav-toggle-mobile"
                        onClick={() => setShowMobileNav((prev) => !prev)}
                        aria-expanded={showMobileNav}
                        aria-controls="mobile-nav"
                        aria-label={t("menu")}
                      >
                        <FontAwesomeIcon icon={faBars} />
                        <span className="app-nav-toggle-label">{t("menu")}</span>
                      </button>
                      <ReportPrint />
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 app-header-button app-header-button-primary app-header-logout-mobile"
                        onClick={handleLogoutClick}
                      >
                        {t("logout")}
                      </button>
                      <div className="app-header-language-mobile">
                        <LanguageSwitcher compact={isTablet} variant="flag" />
                      </div>
                    </div>
                    {(showMobileNav && Consts.DISABLE_PAT_LOGIN === false) && (
                      <div id="mobile-nav" className="w3-left w3-mobile app-nav-mobile app-nav-mobile-panel">
                        <NavigationBarForTablet
                          onResetApp={onResetApp}
                          onNavigate={() => setShowMobileNav(false)}
                          isMobile={isTablet}
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="w3-col s2 w3-mobile w3-padding-small app-header-logo">
                    <img src={mmclogo} alt="MMC logo" className="mmc-logo" />
                  </div>
                  { Consts.DISABLE_PAT_LOGIN === false &&
                    <div className="w3-col s7 w3-mobile"><NavigationBar onResetApp={onResetApp}/></div>
                  }
                  <div className="w3-col s3 w3-mobile">
                    <div className="w3-bar w3-right app-header-actions">
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right app-header-button app-header-button-primary"
                        onClick={handleLogoutClick}
                      >
                        {t("logout")}
                      </button>
                      <div className="w3-right">
                        <LanguageSwitcher variant="flag"/>
                      </div>
                    </div>
                  </div>
                </>
              )
            ) : (
              <>
                <div className="w3-col s12 m5 l5 w3-padding-small app-header-logo"><img src={mmclogo} alt="MMC logo" className="mmc-logo" /></div>
                <div className="w3-col s12 m1 l1 w3-mobile"><div className="w3-container" /></div>
                <div className="w3-col s12 m6 l6 w3-mobile">
                  <div className="w3-bar w3-right w3-mobile app-header-actions">
                    {!loggedIn && (
                      <>
                        <button
                          className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right app-header-button app-header-button-primary"
                          onClick={handleLoginClick}
                        >
                          {t("login")}
                        </button>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://safepolymedac.ics.forth.gr/ac/signup"
                          className="w3-margin-right app-header-link"
                        >
                          <label className="label-link">{t("sign_up")}</label>
                        </a>
                      </>
                    )}
                    {loggedIn && (
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right app-header-button app-header-button-primary"
                        onClick={handleLogoutClick}
                      >
                        {t("logout")}
                      </button>
                    )}
                    <div className="w3-right">
                      <LanguageSwitcher variant="flag"/>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </header>
        <Login showDialog={showLoginDialog} onLogin={handleLogin} />
      </>
    );
  };

  const content = loading ? <Spinner /> : <View />;
  return <div>{content}</div>;
};

export default AppHeader;
